import React from 'react';

interface GradeCellProps {
  value: number | string | null;
}

export const GradeCell: React.FC<GradeCellProps> = ({ value }) => {
  if (value == null || value === '') return <span className="text-ink-400">—</span>;

  // Letras (AD/A/B/C)
  if (typeof value === 'string' && ['AD', 'A', 'B', 'C'].includes(value)) {
    return <span className={`grade-cell ${value}`}>{value}</span>;
  }

  // Números (0-20)
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(n)) return <span className="text-ink-400">—</span>;

  let cls = 'low';
  if (n >= 18) cls = 'high';
  else if (n >= 14) cls = 'ok';
  else if (n >= 11) cls = 'mid';

  return <span className={`grade-cell ${cls}`}>{n.toFixed(n % 1 === 0 ? 0 : 1)}</span>;
};
